import prepareContentItem from './prepare-content-item';
import contentItemsComparator from './content-items-comparator';

const getSortedContent = (content) => content.map(prepareContentItem).sort(contentItemsComparator);

export default getSortedContent;
